import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface OTCPrescriptionsParams {
  patientId: string;
  encounterId?: string;
  enabled: boolean;
}

export interface OTCPrescription {
  encounterId: string;
  carePlanId: string;
  activityId: string;
  details: string;
}

interface OTCPrescriptionResponse {
  otcPrescriptions: OTCPrescription[];
}

export const useOTCPrescriptions = ({
  patientId,
  encounterId,
  enabled,
}: OTCPrescriptionsParams) => {
  return useApi<OTCPrescriptionResponse>({
    queryOptions: {
      enabled: enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<OTCPrescriptionResponse>(
          "/rx/prescriptions/otc",
          { params: { encounterId } },
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.Prescriptions.DEFAULT_OTC(
        patientId,
        encounterId as string,
      ),
    },
  });
};
